import { render, staticRenderFns } from "./NewMenu.vue?vue&type=template&id=ff3653ce&scoped=true"
import script from "./NewMenu.vue?vue&type=script&lang=js"
export * from "./NewMenu.vue?vue&type=script&lang=js"
import style0 from "./NewMenu.vue?vue&type=style&index=0&id=ff3653ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3653ce",
  null
  
)

export default component.exports